import React, { useState } from "react";
import "./survey_form_2.css";
import { BASE_URL, ADD_JOB_APPLICATION } from "../../constants/Apis";


function SurveyForm2({ path, defaultPosition = "" }) {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    contact: "",
    position: defaultPosition, // <-- pre-filled job title
    subjects: "",
    details: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(`${BASE_URL}${ADD_JOB_APPLICATION}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.fullname,
          email: formData.email,
          contact: formData.contact,
          interested_position: formData.position,
          subjects: formData.subjects,
          details: formData.details,
        }),
      });

      const data = await response.json();
      if (data.success) {
        setMessage("✅ Application submitted successfully!");
        setFormData({
          fullname: "",
          email: "",
          contact: "",
          position: "",
          subjects: "",
          details: "",
        });
      } else {
        setMessage("❌ " + (data.message || "Something went wrong."));
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage("⚠️ Unable to submit. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="apply-section">
      <div className="apply-header">
        <h2>Apply for a Position</h2>
        <p>
          Ready to join our team? Fill out the form below and we'll get back to
          you within 24-48 hours.
        </p>
      </div>

      <div className="apply-card">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fullname">Full Name</label>
            <input
              type="text"
              id="fullname"
              name="fullname"
              value={formData.fullname}
              onChange={handleChange}
              placeholder="Enter your full name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact">Contact Number</label>
            <input
              type="tel"
              id="contact"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              placeholder="Enter your contact number"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="position">Interested Position</label>
            <select
              id="position"
              name="position"
              value={formData.position}
              onChange={handleChange}
              required
            >
              <option value="">Select a position</option>
              <option value="Senior Recruitment Consultant">
                Senior Recruitment Consultant
              </option>
              <option value="Business Development Executive">
                Business Development Executive
              </option>
              <option value="HR Operations Specialist">
                HR Operations Specialist
              </option>
              <option value="Digital Marketing Specialist">
                Digital Marketing Specialist
              </option>
              <option value="Training & Development Coordinator">
                Training & Development Coordinator
              </option>
              <option value="Junior Recruitment Intern">
                Junior Recruitment Intern
              </option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* New Field: Subjects */}
          <div className="form-group">
            <label htmlFor="subjects">Subjects / Expertise</label>
            <input
              type="text"
              id="subjects"
              name="subjects"
              value={formData.subjects}
              onChange={handleChange}
              placeholder="E.g. Recruitment, HR, Marketing"
            />
          </div>

          {/* New Field: Details */}
          <div className="form-group">
            <label htmlFor="details">Additional Details</label>
            <textarea
              id="details"
              name="details"
              value={formData.details}
              onChange={handleChange}
              placeholder="Tell us more about your experience or interests..."
              rows="4"
            ></textarea>
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? "Submitting..." : "Send Application"}
          </button>
        </form>

        {message && <p className="response-message">{message}</p>}
      </div>
    </section>
  );
}

export default SurveyForm2;